import colors from './colors';
var _spacingBaseline = 1;
var theme = {
    colors: colors,
    // To be used for things like padding, margin.
    spacing: {
        xxxSmall: _spacingBaseline * 0.125 + "rem",
        xxSmall: _spacingBaseline * 0.25 + "rem",
        xSmall: _spacingBaseline * 0.5 + "rem",
        small: _spacingBaseline * 0.75 + "rem",
        medium: _spacingBaseline + "rem",
        large: _spacingBaseline * 1.5 + "rem",
        xLarge: _spacingBaseline * 2 + "rem",
        xxLarge: _spacingBaseline * 2.5 + "rem",
        xxxLarge: _spacingBaseline * 3 + "rem", // 48px
    },
    // To be used for things like width, height.
    layout: {
        xxSmall: _spacingBaseline + "rem",
        xSmall: _spacingBaseline * 1.5 + "rem",
        small: _spacingBaseline * 2 + "rem",
        medium: _spacingBaseline * 3 + "rem",
        large: _spacingBaseline * 4 + "rem",
        xLarge: _spacingBaseline * 6 + "rem",
        xxLarge: _spacingBaseline * 10 + "rem",
        fill: '100%',
    },
    typography: {
        font: {
            family: {
                // Yummo and Lato are both sans-serif fonts.
                yummo: 'Yummo, Helvetica, sans-serif',
                lato: 'Lato, Helvetica, sans-serif',
                latoVerdana: 'Lato, Verdana, sans-serif',
                yummoVerdana: 'Yummo, Verdana, sans-serif',
            },
            size: {
                xxxSmall: _spacingBaseline * 0.5 + "rem",
                xxSmall: _spacingBaseline * 0.625 + "rem",
                xSmall: _spacingBaseline * 0.75 + "rem",
                small: _spacingBaseline * 0.875 + "rem",
                medium: _spacingBaseline + "rem",
                large: _spacingBaseline * 1.25 + "rem",
                xLarge: _spacingBaseline * 1.5 + "rem",
                xxLarge: _spacingBaseline * 2 + "rem",
                xxxLarge: _spacingBaseline * 3 + "rem", // 48px
            },
            weight: {
                light: '300',
                normal: '400',
                bold: '600',
            },
            lato: {
                weight: {
                    hairline: 100,
                    light: 300,
                    regular: 400,
                    bold: 700,
                    black: 900,
                },
            },
            yummo: {
                weight: {
                    thin: 100,
                    light: 200,
                    regular: 400,
                    semiBold: 600,
                    bold: 700,
                },
            },
        },
        border: {
            radius: {
                xxxSmall: _spacingBaseline * 0.0625 + "rem",
                xxSmall: _spacingBaseline * 0.125 + "rem",
                xSmall: _spacingBaseline * 0.25 + "rem",
                small: _spacingBaseline * 0.375 + "rem",
                medium: _spacingBaseline * 0.5 + "rem",
                large: _spacingBaseline * 0.625 + "rem",
                xLarge: _spacingBaseline * 0.75 + "rem",
                xxLarge: _spacingBaseline + "rem",
                xxxLarge: _spacingBaseline * 1.5 + "rem", // 24px
            },
            width: {
                xxxThin: _spacingBaseline * 0.0625 + "rem",
                xxThin: _spacingBaseline * 0.125 + "rem",
                xThin: _spacingBaseline * 0.25 + "rem",
                thin: _spacingBaseline * 0.375 + "rem",
                normal: _spacingBaseline * 0.5 + "rem",
                thick: _spacingBaseline * 0.625 + "rem",
                xThick: _spacingBaseline * 0.75 + "rem",
                xxThick: _spacingBaseline + "rem",
                xxxThick: _spacingBaseline * 1.5 + "rem", // 24px
            },
            style: {
                solid: 'solid',
                dotted: 'dotted',
                dashed: 'dashed',
                double: 'double',
            },
        },
    },
    style: {
        display: {
            block: 'block',
            flex: 'flex',
            grid: 'grid',
            inlineFlex: 'inline-flex',
            inlineBlock: 'inline-block',
            none: 'none',
        },
        position: {
            absolute: 'absolute',
            static: 'static',
            relative: 'relative',
            sticky: 'sticky',
            fixed: 'fixed',
        },
        textAlign: {
            left: 'left',
            right: 'right',
            center: 'center',
        },
        flexDirection: {
            row: 'row',
            column: 'column',
            rowReverse: 'row-reverse',
            columnReverse: 'column-reverse',
        },
        flexWrap: {
            noWrap: 'nowrap',
            wrap: 'wrap',
            wrapReverse: 'wrap-reverse',
        },
        justifyContent: {
            flexStart: 'flex-start',
            flexEnd: 'flex-end',
            center: 'center',
            spaceBetween: 'space-between',
            spaceAround: 'space-around',
            spaceEvenly: 'space-evenly',
            stretch: 'stretch',
        },
        alignItems: {
            flexStart: 'flex-start',
            flexEnd: 'flex-end',
            center: 'center',
            stretch: 'stretch',
            baseline: 'baseline',
        },
        alignContent: {
            flexStart: 'flex-start',
            flexEnd: 'flex-end',
            center: 'center',
            spaceBetween: 'space-between',
            spaceAround: 'space-around',
            spaceEvenly: 'space-evenly',
            stretch: 'stretch',
            baseline: 'baseline',
        },
        alignSelf: {
            selfStart: 'self-start',
            selfEnd: 'self-end',
            flexStart: 'flex-start',
            flexEnd: 'flex-end',
            center: 'center',
            stretch: 'stretch',
            start: 'start',
            end: 'end',
        },
        overflow: {
            hidden: 'hidden',
        },
    },
};
export default theme;
